import styled from "styled-components";
import { NavLink } from "react-router-dom";

const Com = {};

Com.ImgMain = styled.img`
    position: absolute; 
    top:0; 
    left: 0;
    width:100%;
    height: 100%;
    background-attachment: fixed;
    background-position: 50% 50%;
    background-size: cover;
    filter: brightness(50%);
    object-fit:cover;
`

Com.DivMiddleImg = styled.div`
    width: 100%;
    margin: 0 auto 100px;
    position: relative;
    overflow: hidden;
    padding-top: 20px;
    
    @media all and (max-width: 768px){
        order: 2;
        margin: 0 auto 0px;
    }
`

Com.DivCompImg = styled.div`
    width: 100%;
    margin: 0px;
    position: relative;
    overflow: hidden;
    
    @media all and (max-width: 768px){
        order: 2;
        margin: 0 auto 0px;
    }
`

Com.MiddleGridImg = styled.img`
    @supports ((-o-object-fit:cover) or (object-fit:cover)){
        width: ${props=>props.width};
        height: ${props=>props.height};
        object-fit: cover;
        margin: auto;
        display: block;

        @media all and (max-width: 768px){
            width: 50%;
        }

        @media all and (max-width: 480px){
            width: 70%;
        }
    }
`

Com.MiddleGridImg2 = styled.img`
    @supports ((-o-object-fit:cover) or (object-fit:cover)){
        width: ${props=>props.width};
        height: ${props=>props.height};
        object-fit: cover;
        margin: auto;
        display: block;

        @media all and (max-width: 768px){
            width: 80%;
        }
        @media all and (max-width: 480px){
            width: 90%;
        }
    }
`

Com.MiddleImg = styled.img`
    @supports ((-o-object-fit:cover) or (object-fit:cover)){
        width: ${props=>props.width};
        height: ${props=>props.height};
        object-fit: cover;
        margin: auto;
        display: block;
    }

    @media all and (max-width: 768px){
        object-fit: contain;
        width: 100%;
    }

    @media all and (max-width: 480px){
        object-fit: contain;
        width: 100%;
        height: auto;
    }

`

Com.IntroImg = styled.img`
    @supports ((-o-object-fit:cover) or (object-fit:cover)){
        width: ${props=>props.width};
        height: ${props=>props.height};
        -o-object-fit: cover;
        object-fit: contain;
        margin: auto;
        display: block;
        padding: 20px;
    }

    @media all and (max-width: 768px){
        width: 311px;
        object-fit: contain;
        height: auto;
        margin-top: 22px;
        padding: 20px;
    }

    @media all and (max-width: 480px){
        object-fit: contain;
    }

`

Com.ZoomImg = styled.img`
    @supports ((-o-object-fit:cover) or (object-fit:cover)){
        width: ${props=>props.width};
        height: ${props=>props.height};
        -o-object-fit: cover;
        object-fit: cover;
        margin: auto;
        display: block;
        border-width: 1px;
        border-radius: 10px;
        border-color: #919191;     
    }

    @media all and (max-width: 480px) {
        width: 100%;
    }
`

Com.GridImg = styled.img`
    @supports ((-o-object-fit:cover) or (object-fit:cover)){
        -o-object-fit: cover;
        object-fit: cover;
        margin: auto;
        display: block;
        width: ${props=>props.width};
        height: ${props=>props.height};
        border-radius: 10px;
        background-color: #6976a8;
    }
`

Com.DivDetailSection = styled.section`
    max-width: 1000px;
    margin: 100px auto 80px;

    @media all and (max-width: 1080px) {
        margin: 6px auto 60px;
        padding: 80px 50px 20px;
        position: relative;
        border-top: ${props=>
            props.border==="false"?"0px solid" :"8px solid #ebeef2"
        }
    }
`

Com.DivDetailSection2 = styled.section`
    max-width: 1000px;
    margin: 0px auto;
    margin-top: 50px;

    @media all and (max-width: 1080px){
        margin: 6px auto 60px;
        padding: 80px 50px 20px;
        position: relative;
        border-top: ${props=>
            props.border==="false"?"0px solid" :"8px solid #ebeef2"
            
    }
    }

    @media all and (max-width: 768px){
        padding: 0px 30px;
    }
`

Com.DivDetailSection3 = styled.section`
    max-width: 1000px;
    margin: 0px auto 80px auto;

    @media all and (max-width: 1080px){
        margin: 6px auto 60px;
        padding: 80px 50px 20px;
        position: relative;
        border-top: ${props=>
            props.border==="false"?"0px solid" :"8px solid #ebeef2"
            
        }
    }

    @media all and (max-width: 768px){
        padding: 100px 30px 80px 30px;
        margin: 6px auto 0px auto;
    }
`

Com.DivDetailSection4 = styled.section`
    max-width: 1000px;
    margin: 100px auto 50px auto;

    @media all and (max-width: 1080px){
        margin: 6px auto 60px;
        padding: 100px 50px 20px;
        position: relative;
            
    }

    @media all and (max-width: 768px){
        padding: 100px 30px 50px 30px;
        margin: 6px auto 0px auto;
    }

    @media all and (max-width: 480px){
        padding: 40px 30px 60px 30px;
        margin: 6px auto 0px auto;
    }
`

Com.DivGridDetailSection = styled.section`
    max-width: 810px;
    margin: 80px auto;

    @media all and (max-width: 768px){
        margin: 6px auto 60px;
        padding: 80px 50px 20px;
        position: relative;
        border-top: ${props=>
            props.border==="false"?"0px solid" :"8px solid #ebeef2"
            
        }
    }

    @media all and (max-width: 768px){
        padding: 80px 20px 20px;
    }
`

Com.DivDetailHeading = styled.div`
    text-align: center;
    word-break: keep-all;
    margin-bottom: ${(props) => (props.m !== undefined ? props.m : '80px')};

    @media all and (max-width: 768px){
        padding: 0 24px;
        text-align: center;
        word-break: keep-all;
    }
`
    
Com.DivImgSub = styled.div`
    margin-bottom: 3px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin-top: 20px;
    padding-top: 40px;

    @media all and (max-width: 768px){
        grid-template-columns: none;
    }
    
`

Com.DivImgSub2 = styled.div`
    margin-bottom: 3px;
    display: grid;
    grid-template-columns: 1.3fr 1fr;
    margin-top: 20px;
    padding-top: 40px;

    @media all and (max-width: 768px){
        grid-template-columns: none;
    }
`

Com.DetailHeading = styled.h3`
    font-size: 35px;
    font-family: 'Esamanru';
    font-weight: 500;
    line-height: 1.5;

    @media all and (max-width: 768px){
        font-size: 30px;
        line-height: 1.4;
        margin-top: 50px;
        word-wrap: break-word;
    }

    @media all and (max-width: 480px){
        font-size: 30px;
        line-height: 1.4;
    }
`

Com.DetailHeadingP = styled.p`
    margin-top: 5px;
    font-size: 14px;
    font-family: 'Esamanru';
    font-weight: 300;
    line-height: 1.5;
    color: #393939;
    text-align: center;
    margin-bottom: 20px;

    @media all and (max-width: 768px){
        line-height: 1.4;
    }
`

Com.DetailHeadingSmall = styled.small`
    line-height: 1.75;
    font-size: 18px;
    font-family: 'SUIT Variable';
    font-weight: 300;
`

Com.StrongStrategy = styled.strong`
    font-size: 24px; 
    font-family: 'SUIT Variable';
    font-weight: 800;
    line-height: 30px;
    letter-spacing: -0.3px;
    text-align: center;
    color:#3f44a8;

    @media all and (max-width: 768px){
        line-height: 1.4;
    }
`

Com.StrongStrategyCenter = styled.strong`
    font-size: 24px; 
    font-family: 'SUIT Variable';
    font-weight: 800;
    line-height: 30px;
    letter-spacing: -0.3px;
    position: relative;
    top: 2px;
    text-align: center;
    color:#3f44a8;
    margin-bottom: 30px;

    @media all and (max-width: 768px){
        line-height: 1.4;
        text-align: center;
    }
`

Com.StrongStrategyCenterP = styled.p`
    margin-top: 5px;
    font-size: 18px;
    font-family: 'SUIT Variable';
    font-weight: 400;
    line-height: 1.5;
    color: #393939;
    text-align: center;
    margin-bottom: 60px;

    @media all and (max-width: 768px){
        line-height: 1.4;
    }
`

Com.SpanStrategy = styled.strong`
    font-size: 17px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    margin-top: 4px;
    margin-right: 12px;
    color: #fff;
    font-weight: 500;
    border-radius: 50%;
    background-color: #2b2f89;
    font-family: "Esamanru";
`

Com.SpanHistory = styled.strong`
    font-size: 17px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 65px;
    height: 30px;
    margin-top: 4px;
    margin-right: 12px;
    color: #fff;
    font-weight: 500;
    background-color: #2b2f89;
    font-family: "Esamanru";

    @media all and (max-width: 480px){
        margin-top: 0px;
        margin-right: 0px;
    }
`

Com.BtnNavBarClose = styled.button`
    svg {
        vertical-align: top;
        width: 14px;
        height: 14px;
    }
    @media all and (max-width: 1024px) {
        line-height: 0;
        margin-right: -16px;
        padding: 16px;
    }
`

Com.H3PageHeadTitle = styled.h3`
    text-align: center;
    color: #232324;
    font-size: 30px;
    font-weight: 700;
    line-height: 1.5238095238;
    font-family: 'Esamanru';
    font-weight: 500;
    margin-top: 20px;
`
Com.DivMap = styled.div`
    width : 600px;
    height: 400px;
    margin: 0 auto;
    object-fit: cover;
`;

Com.OlBangHyang = styled.ol`
    display: grid;
    grid-gap: 60px 0px;
    grid-template-columns: 1fr 1fr 1fr;
    list-style: none;
    max-width: 768px;
    margin: auto;

    li {
        margin-left: auto;
        margin-right: auto;
        list-style: unset;
    }

    @media all and (max-width: 768px){
        display: grid;
        grid-gap: 60px 15px;
        text-align: center;
        grid-gap: 20px;
        position: relative;
        padding: inherit;
        grid-template-columns: 1fr 1fr;
        place-content: center;
        margin-left: 100px;
        margin-right: 100px;
    }

    @media all and (max-width: 480px){
        grid-template-columns: 3fr;
    }
`
Com.OlGaeyo = styled.ol`
        display: grid;
        grid-gap: 20px 0px;
        grid-template-columns: 1fr;
        list-style: none;
        max-width: 768px;
        margin: auto;
        position: relative;

    li {
        margin-left: auto;
        margin-right: auto;
        list-style: unset;
    }

    @media all and (max-width: 768px){
       
        li {
            max-width: 448px;
        }
    }

    @media all and (max-width: 480px){
        grid-template-columns: 3fr;
    }
`

Com.POpWay = styled.p`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    padding: 0 15px;
    color: black;
    background-color: white;
    border-radius: 18px;
    border-width: 1.5px;
    border-color: gray;
    font-family: 'Esamanru';
    font-weight: 500;
    font-size: 20px;
    width: 190px;
`

Com.GaeyoTitle = styled.p`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    padding: 0 15px;
    color: black;
    border-color: gray;
    font-family: 'SUIT Variable';
    font-weight: 600;
    font-size: 20px;
    text-align: left;
    line-height: 26px;
    justify-content: space-between;

    @media all and (max-width: 480px){
        justify-content: center;
    }

`

Com.OlInOl = styled.ol`
    flex: none;
    width: 100%;
    margin-top: 20px;
    text-align: left;
    font-family: 'SUIT Variable';
    font-weight: 300;
    font-size: 17px;
    list-style: outside;
    margin-left: 10px;

    li {
        margin-bottom: 14px;
        width: 170px;
    }

    li::marker { 
        font-size: 2px;
        color: gray;
    }

`

Com.GaeyoOl = styled.ol`
    flex: none;
    width: 270px;
    font-family: 'SUIT Variable';
    font-weight: 300;
    font-size: 17px;
    list-style: outside;
    line-height: 26px;
    text-align: left;

    li {
        margin-bottom: 14px;
        width: 170px;
    }

    li::marker { 
        font-size: 2px;
        color: gray;
    }

    @media all and (max-width: 480px){
        text-align: center;
    }

`

Com.DivBoardList = styled.div`
    max-width: 1020px;
    margin: 0 auto 60px;
    padding: 0 50px;

    @media all and (max-width: 768px){
        margin: 0 24px 80px;
    }
`

Com.DivBoardBox = styled.div`
    border-bottom: 1px solid #f3f4f5;
`

Com.LinkBoard = styled(NavLink)`
    display: flex;
    flex-wrap: wrap;
    padding: 40px 20px;

    @media all and (max-width: 768px){
        position: relative;
        padding: 30px 0;
    }
`

Com.DivBoardContent = styled.div`
    flex: 1;
    overflow: hidden;

    @media all and (max-width: 768px){
        position: relative;
    }
`

Com.DivBoardTitle = styled.div`
    font-weight: 700;
    color: #232324;
    text-overflow: ellipsis;
    overflow: hidden;
    max-height: 64px;
    margin-bottom: 10px;
    font-size: 20px;
    line-height: 1.6;
    font-family: 'SUIT Variable';

    @media all and (max-width: 768px){
        max-height: 52px;
        margin-bottom: 5px;
        font-size: 16px;
        line-height: 1.625;    
    }
`

Com.TimeBoard = styled.time`
    position: relative;
    color: #a6a7a9;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.7142857143;
    font-family: 'SUIT Variable';

    @media all and (max-width: 768px){
        font-size: 12px;
        line-height: 1.6666666667;
    }
`

Com.DivLoading = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 200px;
    padding: 60px;
`

Com.MainArticle = styled.main`
    padding-bottom: 160px;
    margin-top: 0;
    padding-top: 72px;

    @media all and (max-width: 1024px){
        padding-top: 50px;
    }
`

Com.SectionArticle = styled.section`
    max-width: 780px;
    margin: 0 auto 0;
    padding-top: 80px;

    @media all and (max-width: 768px){
        margin-bottom: 120px;
        padding-top: 60px;
    }
`

Com.DivArticleHead = styled.div`
    padding-bottom: 80px;
    text-align: center;
    border-bottom: 1px solid #d6d7da;

    @media all and (max-width: 768px){
        padding: 0 24px 80px;
        border-bottom: 10px solid #ebeef2;
    }
`

Com.DivArticleMeta = styled.div`
    margin-bottom: 20px;
`

Com.DivBtnWrap = styled.div`
    text-align: center;
    font-family: 'SUIT Variable';
    font-weight: 400;
    font-size: 17px;
`

Com.PedestalImg = styled.div`
    width: 190px;
    background-color: red;
    border-radius: 28px;
    height: 250px;
    background-image: url(${props => props.imgUrl});
    background-size: contain;
    border: 1px solid #d6d7da;
	margin-top: 40px;
    margin-bottom: 10px;

    @media all and (max-width: 768px){
        margin: auto;
    }
    
`
export default Com;